import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { navLinks, siteMeta } from "@/content/siteContent";

export const Nav = () => {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `editorial-link text-sm font-medium ${isActive ? "opacity-100" : "opacity-70"}`;

  return (
    <header className="sticky top-0 z-50 border-b border-ink/10 bg-sand/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="text-xl font-extrabold uppercase tracking-[0.18em]"
          onClick={() => setOpen(false)}
        >
          {siteMeta.name}
        </Link>
        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={linkClass}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <button
          type="button"
          className="md:hidden"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-button"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav
          className="border-t border-ink/10 px-6 pb-6 pt-4 md:hidden"
          aria-label="Mobile"
          data-testid="mobile-menu"
        >
          <ul className="flex flex-col gap-4">
            {navLinks.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  className="text-lg font-semibold tracking-tight"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
                  onClick={() => setOpen(false)}
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
};
